var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadbandNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4143 0.585815L8.5 8.5L0.585693 16.4142C0.210693 16.7893 0 17.298 0 17.8284V37.5858C0 38.4767 1.07715 38.9229 1.70703 38.2929L20 20L38.293 1.70709C38.9229 1.07715 38.4768 0 37.5857 0H17.8284C17.2981 0 16.7893 0.210693 16.4143 0.585815ZM11.9014 22.9894L13.3525 21.5385L7.39575 15.5818L5.94482 17.0328L9.63599 20.7238L3.51807 19.4595L2.06714 20.9105L8.02368 26.8672L9.47461 25.4162L5.80054 21.7421L11.9014 22.9894ZM12.2659 15.4464L11.061 14.2415L13.2588 12.0438L12.0962 10.8813L8.44751 14.53L14.4043 20.4866L18.053 16.838L16.8904 15.6755L14.6926 17.8732L13.386 16.5665L15.3291 14.6234L14.209 13.5033L12.2659 15.4464ZM25.6389 9.25201L21.2351 1.74255L19.6738 3.30383L23.1443 8.50531L17.79 5.18756L16.1948 6.78278L19.47 12.1794L14.2771 8.70044L12.7244 10.2533L20.1914 14.6996L21.9478 12.9431L19.012 8.03864L23.8823 11.0085L25.6389 9.25201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadbandNew);
export default __webpack_public_path__ + "static/media/headband_new.138d5843444220249b3b3b9a9fefc9a6.svg";
export { ForwardRef as ReactComponent };